import { defineMessages } from "react-intl";

export const refundTableMessages = defineMessages({
  all: {
    id: "MZDkkX",
    defaultMessage: "All",
    description: "button label",
  },
  alreadyRefunded: {
    id: "fITtdb",
    defaultMessage: "{value} already refunded",
    description: "helper text",
  },
  maxToRefund: {
    id: "MIp3c7",
    defaultMessage: "of {value}",
    description: "input adornment helper text",
  },
  addReason: {
    id: "Fxahwt",
    defaultMessage: "Add refund reason for this line",
    description: "modal title",
  },
  editReason: {
    id: "PALiyV",
    defaultMessage: "Edit refund reason for this line",
    description: "modal title",
  },
  addReasonBtn: {
    id: "B1yzuX",
    defaultMessage: "Add reason",
    description: "button label",
  },
  editReasonBtn: {
    id: "I5vC7T",
    defaultMessage: "Edit reason",
    description: "button label",
  },
  allItemsRefunded: {
    id: "WigK1f",
    defaultMessage: "All items refunded",
    description: "helper text",
  },
});
